import React from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { Search, X } from "lucide-react";
import { useTranslation } from "react-i18next";

interface Props {
    value: string;
    onChange: (value: string) => void;
    onSubmit: () => void;
}

const AssetSearchBar: React.FC<Props> = ({ value, onChange, onSubmit }) => {
    const { i18n } = useTranslation();
    const t = (key: string, options?: object) => (i18n.t as unknown as (key: string, options?: object) => string)(key, options);

    return (
        <InputGroup className="asset-search-bar">
            <InputGroup.Text><Search size={18} /></InputGroup.Text>
            <Form.Control
                value={value}
                placeholder={t('track_trace.search.placeholder')}
                onChange={(event) => onChange(event.target.value)}
                onKeyDown={(event) => event.key === 'Enter' && onSubmit()}
            />
            {value && <Button variant="light" onClick={() => onChange('')} aria-label={t('track_trace.search.clear')}><X size={18} /></Button>}
            <Button variant="primary" onClick={onSubmit}>{t('track_trace.search.submit')}</Button>
        </InputGroup>
    );
};

export default AssetSearchBar;
